/**
 * Copyright (C) BoostCommerce.net
 * This file is part of commercial BoostCommerce.net projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * Created on Tue Feb 14 2023 19:26:12
 */

// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';
import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DropdownIndicator, styles } from './react-select-style';
import { RenderSelect2 } from 'src/components/views/common/forms/render-select-2-v2';

import { RenderRadioButton2 } from 'src/components/views/common/forms/render-radio-button-2';
import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import {
  PAGINATION_TYPE_OPTIONS,
  PAGINATION_PRODUCT_COUNT_POSITION_OPTIONS,
  PAGINATION_TYPE
} from 'src/constants/theme-settings.js';
import { MENU_ID, PAGINATION_ALIGNMENT_OPTIONS_TEXT } from 'src/constants/theme-settings.jsx';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  themeSettingDefaultValue: any,
  themeSettingDefaultThemeValue: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductListPaginationForm extends Component<ComposedProps> {
  state = {
    isOpenedTextStyle: true,
    isOpenedButtonStyle: true
  };

  handleChangePaginationType = type => {
    // Apply change value when update pagination type
    const { updateField, formValues } = this.props;
    const setting = _.get(formValues, `pagination.${type}`);
    updateField(`setting.${MENU_ID.PAGINATION}`, setting);
  };

  render() {
    const { i18n, formValues } = this.props;

    const paginationType = _.get(formValues, `setting.${MENU_ID.PAGINATION}.paginationType`);
    const isPageLink = paginationType === PAGINATION_TYPE.PAGE_LINKS;
    const isLoadMore = paginationType === PAGINATION_TYPE.LOAD_MORE;

    const productCountChecked = _.get(
      formValues,
      `setting.${MENU_ID.PAGINATION}.productCount.showProductCount`
    );

    const paginationTypeOptions = PAGINATION_TYPE_OPTIONS.map(option => {
      const { label, value } = option;
      return { label: i18n.translate(label), value };
    });

    const paginationAlignmentOptions = PAGINATION_ALIGNMENT_OPTIONS_TEXT.map(option => {
      const { label, value } = option;
      return { label: i18n.translate(label), value };
    });

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.pagination_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['PaginationThemeSetting']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <div className="form-section">
          <div className="form-section__item">
            <Field
              name={`setting.${MENU_ID.PAGINATION}.paginationType`}
              label={i18n.translate('AdminHTML.ThemeSetting.Form.pagination_PaginationType_Label')}
              options={paginationTypeOptions}
              component={RenderSelect2}
              components={{ DropdownIndicator }}
              styles={styles}
              isSearchable={false}
              onChange={this.handleChangePaginationType}
            />
          </div>

          {(isPageLink || isLoadMore) && (
            <div className="form-section__item form-section__item--medium-spacing">
              <p className="title">
                {i18n.translate('AdminHTML.ThemeSetting.Form.pagination_PaginationAlignment_Label')}
              </p>
              <div className="radio-button-wrapper radio-button-wrapper--no-gap radio-button-wrapper--no-radius-middle">
                {paginationAlignmentOptions.map((item, index) => (
                  <Field
                    key={index}
                    name={`setting.${MENU_ID.PAGINATION}.alignment`}
                    id={item.value}
                    component={RenderRadioButton2}
                    label={item.label}
                  />
                ))}
              </div>
            </div>
          )}

          {(isPageLink || isLoadMore) && (
            <div className="form-section__item form-section__item--standard-spacing">
              <Field
                name={`setting.${MENU_ID.PAGINATION}.productCount.showProductCount`}
                component={RenderCheckbox}
                label={i18n.translate(
                  'AdminHTML.ThemeSetting.Form.pagination_ProductCountCheckbox_Label'
                )}
              />
            </div>
          )}

          {productCountChecked && (isPageLink || isLoadMore) && (
            <div className="form-section__item">
              <p>
                {i18n.translate(
                  'AdminHTML.ThemeSetting.Form.pagination_ProductCountPosition_Label'
                )}
              </p>
              <div
                className="radio-button-wrapper radio-button-wrapper--no-gap radio-button-wrapper--bordered"
                style={{ marginTop: '5px' }}>
                {PAGINATION_PRODUCT_COUNT_POSITION_OPTIONS.map((item, index) => (
                  <Field
                    key={index}
                    name={`setting.${MENU_ID.PAGINATION}.productCount.position`}
                    id={item.value}
                    component={RenderRadioButton2}
                    label={i18n.translate(item.label)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductListPaginationForm);
